export function initInitialState($form, h) {
  const { hide } = h

  function apply() {
    // reservista (controlado pelo modulo reservista.js)
    hide($form.find(".params_movimentacoes_pessoal_certificado_reservista"))
    hide($form.find(".params_codigo_reservista"))

    // taxa de manobra (controlado pelo modulo cargo_salario.js — só aparece para cargos de veículos)
    hide($form.find(".params_taxa_manobra"))

    // cnh (controlado pelo modulo cnh.js — oculto via style:display:none na view)

    // vale transporte condicionais
    hide($form.find(".params_numero_cartao_vale_transporte"))
    hide($form.find(".params_esta_desvinculado_da_empresa_anterior"))
    hide($form.find(".params_entrar_em_contato_antiga_empresa"))
    hide($form.find(".params_valor_ticket_alimentacao"))
    hide($form.find(".params_valor_ticket_refeicao"))

    hide($form.find(".params_tipo_desconto_contracheque"))
    hide($form.find(".params_desconto_em_contracheque"))
    hide($form.find(".possui_cartao_bilhete_unico"))

    // limpa textos auxiliares
    $form.find(".doc-text").remove()

    // Validação em tempo real: data de admissão deve ser > hoje + 2 dias
    const $dataAdmissao = $form.find('[name="params[data_admissao]"]')
    const $dataAlerta   = $form.find('#data-admissao-alerta')
    if ($dataAdmissao.length && $dataAlerta.length) {
      const checkDataAdmissao = () => {
        const raw = ($dataAdmissao.val() || '').trim()
        if (!raw) { $dataAlerta.addClass('hidden'); return }

        // Aceita DD/MM/YYYY (formato BR do datepicker) ou YYYY-MM-DD (ISO)
        let dateObj
        const br  = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
        const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/)
        if (br)       dateObj = new Date(+br[3],  +br[2]  - 1, +br[1])
        else if (iso) dateObj = new Date(+iso[1], +iso[2] - 1, +iso[3])
        else          { $dataAlerta.addClass('hidden'); return }

        if (isNaN(dateObj.getTime())) { $dataAlerta.addClass('hidden'); return }

        const minDate = new Date()
        minDate.setHours(0, 0, 0, 0)
        minDate.setDate(minDate.getDate() + 2)

        dateObj <= minDate
          ? $dataAlerta.removeClass('hidden')
          : $dataAlerta.addClass('hidden')
      }

      $dataAdmissao.on('change blur', checkDataAdmissao)
      checkDataAdmissao() // aplica no init (modo edição)
    }

    // Sincroniza CPF do campo de consulta → campo de documentos.
    // O mapper SOA já faz isso no retorno bem-sucedido; este fallback garante
    // que o campo seja preenchido mesmo se a consulta falhar ou não disparar.
    const $cpfLookup = $form.find('#soa_admissao')
    const $cpfDoc    = $form.find('#params_cpf')
    if ($cpfLookup.length && $cpfDoc.length) {
      $cpfLookup.on('change', function () {
        if ($cpfLookup.val() && !$cpfDoc.val()) {
          $cpfDoc.val($cpfLookup.val()).trigger('input').trigger('change')
        }
      })
      // Sincroniza na inicialização (ex: Turbo restaurou o valor do cache)
      if ($cpfLookup.val() && !$cpfDoc.val()) {
        $cpfDoc.val($cpfLookup.val()).trigger('input').trigger('change')
      }
    }

    // Padrão: carteira de trabalho digital marcada em novos cadastros.
    // Em edição (form com _method=PATCH/PUT), respeita o valor salvo.
    const isEditMode = $form.find('input[name="_method"]').length > 0
    if (!isEditMode) {
      const $ctpsDigital = $form.find("#params_carteira_trabalho_digital")
      if ($ctpsDigital.length && !$ctpsDigital.is(":checked")) {
        $ctpsDigital.prop("checked", true)
        // Dispara change para que ctps_digital_controller reaja e
        // esconda / desabilite os campos de CTPS física.
        $ctpsDigital[0].dispatchEvent(new Event("change", { bubbles: true }))
      }
    }
  }

  apply()
  return { destroy() { } }
}
